/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @date  2018/6/15 13:35
 * @des 检测session
 */

const AccountFetch = require('@/base/store/accountfetch')
import Constants from '@/base/constants'
import {setSessionCookieExpires} from './util/cookieutil'
import {
  getItem,
  setItem,
  removeItem
} from '@/base/store/storage'
import {Message} from 'element-ui'

const USER_KEY = 'currentuser'

/**
 * 检测session
 */
export function checkSession (showTip = true) {
  AccountFetch.getUsername().then((username) => {
    setItem(USER_KEY, username)
    setSessionCookieExpires()
    if (showTip) {
      Message({
        type: 'success',
        message: '当前登录账号:' + username,
      })
    }
  }).catch((err) => {
    if (err.code === 3000) {
      removeCurrentUser()
      err.showErr = false
      if (Constants.DEBUG) {
        AccountFetch.login('aaaaaa', '123456').then((data) => {
          Message({
            type: 'warning',
            message: '登录测试账号:aaaaaa',
          })
        })
      } else {
        window.location.assign(Constants.LOGIN_URL + encodeURIComponent(window.location.href))
      }
    }
  })
}

/**
 * 获取当前用户
 * @param callback
 * @returns {*}
 */
export function getCurrentUser (callback) {
  let user = getItem(USER_KEY)
  if (user == null) {
    AccountFetch.getUsername().then((username) => {
      setItem(USER_KEY, username)
      callback(username)
    }).catch((e) => {
      e.showErr = false
      callback(null)
    })
  } else {
    callback(user)
  }
  setSessionCookieExpires()
}

/**
 * 移除当前用户的缓存信息
 */
export function removeCurrentUser () {
  removeItem(USER_KEY)
}



// WEBPACK FOOTER //
// ./src/base/sessioncheck.js